import routesMap from "@/router/routesMap";

export let getRouterMenuList = () => {
  let accountInfo = JSON.parse(sessionStorage.getItem("accountInfo"));
  let menuList = [];
  if (accountInfo.account_type == 3) {
    menuList = routesMap.superRoutes;
  } else if (accountInfo.account_type == 2) {
    menuList = routesMap.merchantRoutes;
  } else if (accountInfo.account_type == 1) {
    menuList = routesMap.shopRoutes;
  }
  // 注意accountInfo.role_permission返回的元素必须要用双引号。
  let rolePermissionList = eval("(" + accountInfo.role_permission + ")");
  let newMenuList = [];
  // 通过router列表与用户选择的权限列表进行遍历，最后得到用户当前权限的路由列表
  menuList.map(v => {
    if (rolePermissionList.indexOf(v.id) != -1) {
      if (v.children.length > 1) {
        newMenuList.push({
          title: v.title,
          id: v.id,
          icon: v.icon,
          path: v.path,
          children: []
        });
        v.children.map(c => {
          if (rolePermissionList.indexOf(c.id) != -1) {
            newMenuList.map(b => {
              if (b.id == v.id) {
                b.children.push({
                  title: c.title,
                  path: c.path,
                  id: c.id
                });
              }
            });
          }
        });
      } else {
        newMenuList.push({
          title: v.title,
          id: v.id,
          icon: v.icon,
          path: v.path,
          children: v.children
        });
      }
    }
  });
  return newMenuList
}



// WEBPACK FOOTER //
// ./src/assets/js/getRouterMenuList.js